import { removeDuplicates } from "../../../helpers/Arrays";
import { documentConstants } from "../../constants";

const defaultState = {
  items: [],
  item: {},
  unsent: [],
  loadingItems: false,
  loadingItem: false,
  loadingUnsent: false,
  fetchedItems: false,
  fetchedItem: false,
  fetchedUnsent: false,
  error: null,
};

function normalData(arr) {
  if (!Array.isArray(arr)) return [];

  return arr.map((elem, index) => {
    // Определяем, есть ли данные из заказа
    const hasOrder = elem.shipmentOrders && elem.shipmentOrders.length > 0 && elem.shipmentOrders[0].orderCustomer;
    const customerId = hasOrder
      ? elem.shipmentOrders[0]?.orderCustomer?.customer?.id
      : elem.contractor?.id || null;
    const customerLabel = hasOrder
      ? `${elem.shipmentOrders[0]?.orderCustomer?.customer?.name} (ИНН: ${elem.shipmentOrders[0].orderCustomer?.customer.inn})`
      : (elem.contractor ? `${elem.contractor.name} (ИНН: ${elem.contractor.inn || ''})` : "");

    return Object.assign(elem, {
      index: index + 1,
      whoCreated: typeof elem.whoCreated === 'object'
        ? `${elem.whoCreated.firstName} ${elem.whoCreated.lastName}`
        : elem.whoCreated,
      customerId: customerId,
      customerLabel: customerLabel,
      storageShipment: elem.items?.map(el => el?.storage?.nameStorage).find(name => name != null) || '',
    });
  });
}

function normalUnsent(arr) {
  if (!Array.isArray(arr)) return [];

  var normalData = arr.map((elem, index) =>
    Object.assign(elem, {
      index: index + 1,
      id: index + 1,
      article: elem.nomenclature.article,
      nomenclature: elem.nomenclature.nameNomenclature,
      nomenclatureId: elem.nomenclature.id,
      characteristicId: elem.characteristic?.id ?? null,
      characteristic: elem.characteristic?.name ?? null,
      isManufactured: elem.nomenclature.isManufactured,
      hasSerial: elem.nomenclature.hasSerial,
      serialNumber: elem.product?.serialNumber,
      productId: elem.product?.id ?? null,
      category: elem.nomenclature.category ? elem.nomenclature.category.nameCategory : "Не указано",
      unit: elem.nomenclature.unit ? elem.nomenclature.unit.nameUnit : "Не указано",
      taxOrder: elem.tax ? elem.tax.nameTax : "Не указано",
      taxOrderId: elem.tax ? elem.tax.id : null,
      taxObjId: elem.tax ? elem.tax.id : null,
      customerId: elem.customer.id,
      customer: elem.customer.name,
      hasFractional: elem.nomenclature.hasFractional,
      isProduct: elem.product ? true : false,
      countAvailable: elem.countAvailable
    })
  );
  return normalData;
}

export const shipmentReducer = function (state = defaultState, action) {
  switch (action.type) {
    case documentConstants.SET_ITEM_LOADING_SHIPMENT:
      return {
        ...state,
        loadingItem: action.isLoading,
      };
    case documentConstants.GETALL_REQUEST_SHIPMENT:
      return {
        ...state,
        item: {},
        loadingItems: true,
        loadingItem: false,
        fetchedItems: false,
        fetchedItem: false,
        error: null,
      };
    case documentConstants.GETALL_SUCCESS_SHIPMENT:
      return {
        ...state,
        items: normalData(action.response),
        loadingItems: false,
        fetchedItems: true,
      };
    case documentConstants.GETALL_FAILURE_SHIPMENT:
      return {
        ...state,
        loadingItems: false,
        fetchedItems: false,
        error: action.error,
      };

    case documentConstants.GETBYID_REQUEST_SHIPMENT:
      return {
        ...state,
        item: {},
        loadingItem: true,
        fetchedItem: false,
        error: null,
      };
    case documentConstants.GETBYID_SUCCESS_SHIPMENT:
      const existingItem = state.items.find(item => item.id === action.response.id && item.viewStatus?.status !== action.response?.viewStatus?.status);
      if (existingItem) {
        // Обновляем существующий элемент в общем списке
        return {
          ...state,
          items: state.items.map(item => {
            if (item.id !== action.response.id) {
              return item;
            }
            item.orders = action.response?.orders;
            item.customerId = action.response?.orders && action.response.orders.length > 0
              ? action.response.orders[0]?.customer?.id
              : null;
            item.customerLabel = action.response?.orders && action.response.orders.length > 0
              ? `${action.response.orders[0]?.customer?.name} (ИНН: ${action.response.orders[0].customer.inn})`
              : "";
            item.whoCreated = action.response?.whoCreated?.firstName + " " + action.response?.whoCreated?.lastName;
            item.viewStatus = action.response?.viewStatus;
            return item;
          }),
          item: action.response,
          loadingItem: false,
          fetchedItem: true,
        };
      }
      else {
        return {
          ...state,
          item: action.response,
          loadingItem: false,
          fetchedItem: true,
        }

      };
    case documentConstants.GETBYID_FAILURE_SHIPMENT:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        error: action.error,
      };

    case documentConstants.CREATE_REQUEST_SHIPMENT:
      return {
        ...state,
        item: {},
        loadingItem: true,
        fetchedItem: false,
        error: null,
      };
    case documentConstants.CREATE_SUCCESS_SHIPMENT:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: true,
        items: normalData(state.items.concat(action.response)),
        item: action.response,
      };
    case documentConstants.CREATE_FAILURE_SHIPMENT:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        error: action.error,
      };

    case documentConstants.UPDATE_REQUEST_SHIPMENT:
      return {
        ...state,
        loadingItem: true,
        fetchedItem: false,
        error: null,
      };
    case documentConstants.UPDATE_SUCCESS_SHIPMENT:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: true,
        item: action.response,
        items: normalData(
          state.items.map((elem) => {
            if (elem.id === action.response.id) return Object.assign(elem, { ...action.response });
            return elem;
          })
        ),
      };
    case documentConstants.UPDATE_FAILURE_SHIPMENT:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        error: action.error,
      };

    case documentConstants.ARCHIVE_REQUEST_SHIPMENT:
      return {
        ...state,
        loadingItem: true,
        fetchedItem: false,
        error: null,
      };
    case documentConstants.ARCHIVE_SUCCESS_SHIPMENT:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        items: normalData(
          state.items.map((elem) => {
            if (elem.id === action.id)
              return Object.assign(elem, { ...action.response, isArchive: !elem.isArchive });
            return elem;
          })
        ),
      };
    case documentConstants.ARCHIVE_FAILURE_SHIPMENT:
      return {
        ...state,
        loadingItem: false,
        error: action.error,
      };

    case documentConstants.UNSENT_REQUEST_SHIPMENT:
      return {
        ...state,
        loadingUnsent: true,
        error: null,
      };
    case documentConstants.UNSENT_SUCCESS_SHIPMENT:
      return {
        ...state,
        unsent: normalUnsent(action.response),
        loadingUnsent: false,
        fetchedUnsent: true,
      };
    case documentConstants.UNSENT_FAILURE_SHIPMENT:
      return {
        ...state,
        loadingUnsent: false,
        fetchedUnsent: false,
        error: action.error,
      };

    case "RESET_ITEM_SHIPMENT":
      return {
        ...state,
        fetchedItem: false,
        loadingItem: false,
        item: {},
      };

    case "RESET_ITEMS_SHIPMENT":
      return {
        ...state,
        fetchedItems: false,
        loadingItems: false,
        items: [],
        error: null,
      };
    case "RESET_UNSENT_SHIPMENT":
      return {
        ...state,
        fetchedItem: false,
        loadingItem: false,
        unsent: {},
      };
    default:
      return state;
  }
};
